module.exports = __webpack_public_path__ + "static/media/Instagram.bf05eee0.webp";